import { useState } from 'react';
import { Button } from '@iwoca/orion';
import { useRouterApplicationId } from 'components/Signup/hooks/useRouterApplicationId';
import { useSignupStep } from 'components/Signup/hooks/useSignupStep';
import { useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const ContinueToDocuments = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const applicationId = useRouterApplicationId();
  const { updateLatestAllowedStep } = useSignupStep();

  const handleClick = async () => {
    setIsLoading(true);
    await updateLatestAllowedStep('new/documents');
    navigate(PATH_NAMES.newApplicationDocuments({ applicationId }));
    setIsLoading(false);
  };

  return (
    <Button
      variant="denim"
      data-testid="continue-to-documents"
      loading={isLoading}
      onClick={handleClick}
    >
      Upload documents
    </Button>
  );
};
